import { api } from './apiService';

export class CreditsError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CreditsError';
  }
}

export class SearchApiError extends Error {
  constructor(status, message, details) {
    super(message);
    this.name = 'SearchApiError';
    this.status = status;
    this.details = details;
  }
}

function mapAxiosError(err) {
  const status = err.response?.status;
  const body = err.response?.data || {};
  const message = body.message || body.error || err.message || 'Request failed';
  if (status === 402) {
    return new CreditsError(message);
  }
  return new SearchApiError(status || 0, message, body.details);
}

/**
 * POST /api/icp/person-search — NL + local DB (up to 8), then PDL merge when needed.
 * @param {object} payload — nlSearchQuery, clusters and/or queries, size_per_query, etc.
 */
export async function personSearch(payload) {
  try {
    const { data } = await api.post('/icp/person-search', payload);
    return data;
  } catch (err) {
    throw mapAxiosError(err);
  }
}

/**
 * POST /api/profile-nl-search — Mongo NL search with pagination (no PDL).
 * @param {{ query: string; page?: number; limit?: number }} payload
 */
export async function profileNlSearch(payload) {
  try {
    const { data } = await api.post('/profile-nl-search', payload);
    return data;
  } catch (err) {
    throw mapAxiosError(err);
  }
}
